import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import { createModule } from 'vuex-toast'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	customState: 0,
    noteDrawer: false,
    drawerListState: 0,
    selectedNote: null,
    educationDrawer: false,
    educationModuleId: null,
    user: null,
    changeTeamState: 0
  },

  getters: {
    getUser (state) {
      return state.user
    },
    noteDrawer (state) {
      return state.noteDrawer
    },
    selectedNote (state) {
      return state.selectedNote
    }
  },

  mutations: {
    setUser (state, user) {
      state.user = user
    },
  	incrementState (state) {
      state.customState ++
    },
    incrementDrawerListState (state) {
      state.drawerListState ++
    },
    openNoteDrawer (state) {
      state.noteDrawer = true
    },
    closeNoteDrawer (state) {
      state.noteDrawer = false
    },
    setCurrentNote (state, note) {
      state.selectedNote = note
    },

    // education section
    setEducationModuleId (state, id) {
      state.educationModuleId = id
    },
    openEducationDrawer (state) {
      state.educationDrawer = true
    },
    closeEducationDrawer (state) {
      state.educationDrawer = false
    },

    // detect team change
    inctementChangeTeamState (state) {
      state.changeTeamState ++
    },
  },

  actions: {
  	//
  },

  modules: {
  	auth,
    toast: createModule({
      dismissInterval: 5000
    })
  }
})
